import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const DeleteFamilyMemberMutation = graphql.persisted(
  "DeleteFamilyMember",
  graphql(`
    mutation DeleteFamilyMember($familyId: ID!, $personId: ID!, $deletePerson: Boolean) {
      deleteFamilyMember(input: {familyId: $familyId, personId: $personId, deletePerson: $deletePerson}) {
        success
        deletedPerson
        userErrors { message path }
      }
    }
  `)
);

export { DeleteFamilyMemberMutation };

export function useDeleteFamilyMember() {
  return useMutation(DeleteFamilyMemberMutation);
}
